import { Suspense } from 'react';
import { Outlet } from 'react-router-dom';

import PageLoader from '@/routes/page-loader';
import RouteErrorBoundary from '@/routes/route-error-boundary';
import DocumentTitle from '@/shared/routes/document-title';
import PageTitleProvider from '@/shared/routes/page-title-provider';

/**
 * Root layout: the one route every zone hangs off.
 *
 * With a data router nothing can sit *around* the route tree the way it could
 * around <Routes>, so the error boundary and the <Suspense> that serves the
 * lazy route chunks live here instead. Pathless, so it adds no URL segment.
 *
 * <DocumentTitle> sits above the outlet so every route (public ones included)
 * takes its browser-tab title from its route handle.
 */
export default function RootLayout() {
  return (
    <RouteErrorBoundary>
      <PageTitleProvider>
        <DocumentTitle />
        <Suspense fallback={<PageLoader />}>
          <Outlet />
        </Suspense>
      </PageTitleProvider>
    </RouteErrorBoundary>
  );
}
